import { activationStrategy } from 'aurelia-router';
import { DataType, ProjectionPropertyOrdering } from '../../../models/queries/queries.models';
import moment from "moment";
var ChildComponent = /** @class */ (function () {
    function ChildComponent(notificationService, i18N) {
        this.notificationService = notificationService;
        this.i18N = i18N;
        this.resetAfterSubmit = true;
    }
    Object.defineProperty(ChildComponent.prototype, "item", {
        get: function () {
            return this._item;
        },
        set: function (x) {
            this._item = x;
            this.onItemChanged();
        },
        enumerable: false,
        configurable: true
    });
    ChildComponent.prototype.determineActivationStrategy = function () {
        return activationStrategy.replace;
    };
    ChildComponent.prototype.activate = function (model) {
        this.item = typeof (model) == "string" ? this.parse(model) : model;
        this.onActivated(this.item);
    };
    ChildComponent.prototype.onActivated = function (model) { };
    ChildComponent.prototype.parse = function (obj) {
        return JSON.parse(obj.replace(new RegExp("&quot;", "g"), "\"")
            .replace(new RegExp("&gt;", "g"), ">")
            .replace(new RegExp("&lt;", "g"), "<"));
    };
    Object.defineProperty(ChildComponent.prototype, "entityType", {
        get: function () {
            if (this.item) {
                return this.item["entityType"];
            }
        },
        enumerable: false,
        configurable: true
    });
    ChildComponent.prototype.onItemChanged = function () {
    };
    ChildComponent.prototype.generateDefaultColumn = function (property) {
        var column = {
            name: property.name,
            title: property.friendlyName,
            dataType: property.type,
            isHidden: !property.showByDefault,
            isFilterable: true,
            isSortable: false,
            isGrouping: false,
            sortOrder: 0,
            groupOrder: 0,
            columnOrder: 0
        };
        if (column.isAscending == null && property.defaultOrdering == ProjectionPropertyOrdering.Ascending) {
            column.isAscending = true;
            column.isSortable = true;
        }
        if (column.isAscending == null && property.defaultOrdering == ProjectionPropertyOrdering.Descending) {
            column.isAscending = false;
            column.isSortable = true;
        }
        if (property.type === DataType.Date || property.type === DataType.DateTime && !column.valueConverter) {
            column.valueConverter = function (value) { return value ? moment(value).format(property.format) : ''; };
        }
        return column;
    };
    return ChildComponent;
}());
export { ChildComponent };
